var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardUiPaymentSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.3457031,4,1,5.3457031,1,7v18c0,1.6542969,1.3457031,3,3,3h24c1.6542969,0,3-1.3457031,3-3V7 C31,5.3457031,29.6542969,4,28,4z M3,10h26v2H3V10z M29,25c0,0.5517578-0.4482422,1-1,1H4c-0.5517578,0-1-0.4482422-1-1V14h26V25z  M3,8V7c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1v1H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,23h4c0.5527344,0,1-0.4472656,1-1v-4c0-0.5527344-0.4472656-1-1-1H7c-0.5527344,0-1,0.4472656-1,1v4 C6,22.5527344,6.4472656,23,7,23z M8,19h2v2H8V19z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 5,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUiPaymentSmall);
export default __webpack_public_path__ + "static/media/card-ui-payment--small.29549cb9c1c8b897ded9f5cb65c24a59.svg";
export { ForwardRef as ReactComponent };